import __request__ from "routing/request";
export function list(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.llm/feature-models", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setAll(request, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.llm/feature-models", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(featureId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.llm/feature-models/${featureId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(featureId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.llm/feature-models/${featureId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function set(featureId, model, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.llm/feature-models/${featureId}`, model, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
